/*!
  Elysian, by Koding Themes
  global.js
  https://kodingthemes.com
*/

let globalSectonsFunction = {
  // Function creates sliders for featured collection/products section
  featuredSectionSlider: function (e) {
    // select all slider parents
    var allSliders = document.querySelectorAll(
      ".featured-collection,.featured-products"
    );
    if (allSliders.length > 0) {
      allSliders.forEach(function (sliderElement) {
        var sliderParent = sliderElement.closest("section");
        var sliderId = sliderParent.getAttribute("id");
        //slider
        var slider = tns({
          container: sliderElement,
          items: 1,
          disable: false,
          slideBy: "1",
          nav: false,
          speed: 400,
          mode: "carousel",
          prevButton: "#" + sliderId + " .js-slider-sites-prev",
          nextButton: "#" + sliderId + " .js-slider-sites-next",
          navPosition: "bottom",
          autoplayButtonOutput: false,
          mouseDrag: true,
          autoplay: false,
          controls: true,
          freezable: true,
          touch: true,
          preventScrollOnTouch: "true",
          rewind: true,
          lazyload: true,
          center: false,
          loop: true,
          controlsContainer: "#" + sliderId + " .controls",
          onInit(info) {
            info.controlsContainer.setAttribute("tabindex", -1);
            info.nextButton.setAttribute("tabindex", -1);
            info.prevButton.setAttribute("tabindex", -1);
          },
          responsive: {
            300: {
              items: 1,
              disable: false,
            },
            768: {
              items: 2,
              disable: false,
            },
          },
        });
      });
    }
  },
  // Function creates accordion mobile view for Alternative rich text section
  alternativeRichTextSection: function () {
    var cols = document.querySelectorAll(".alternative-rich-text-col");
    if (cols.length > 0) {
      cols.forEach(function (col) {
        var heading = col.querySelector(".content-title");
        var content = col.querySelector(".alternative-rich-text-content");
        heading.onclick = function () {
          col.classList.toggle("active-tab");
        };
      });
    }
  },
  bundleProductsSection: function () {
    var bundleBtns = document.querySelectorAll(".add-to-cart-bundle-button");
    if (bundleBtns.length > 0) {
      bundleBtns.forEach(function (bundleBtn) {
        var sectionWrp = bundleBtn.closest(".main-product-bundle-wrp");
        if (sectionWrp != null) {
          bundleBtn.onclick = function () {
            var checkboxes = sectionWrp.querySelectorAll(
              'input[name="bundleproduct"]:checked'
            );
            if (checkboxes.length > 0) {
              var ids = [];
              checkboxes.forEach(function (checkbox) {
                var var_id = checkbox.value;
                var selling_plan = checkbox
                  .closest(".bundle-item-add-button")
                  .querySelector('input[name="selling_plan"]');
                if (selling_plan != null) {
                  ids.push({
                    var_id: var_id,
                    selling_plan: selling_plan.value,
                  });
                } else {
                  ids.push({
                    var_id: var_id,
                  });
                }
                checkbox.checked = false;
              });
              // register an event listener
              var eventBundleProducts = new CustomEvent(
                "shopify-bundle-products:init-product-bundle",
                {
                  detail: {
                    variant_ids: ids,
                    bundleBtn: bundleBtn,
                  },
                }
              );
              document.dispatchEvent(eventBundleProducts);
            }
          };
          // Checkbox change
          var checkboxes = sectionWrp.querySelectorAll(
            'input[name="bundleproduct"]'
          );
          if (checkboxes.length > 0) {
            checkboxes.forEach(function (checkbox) {
              checkbox.onchange = function () {
                var checkboxesChecked = sectionWrp.querySelectorAll(
                  'input[name="bundleproduct"]:checked'
                );
                if (checkboxesChecked.length == checkboxes.length) {
                  bundleBtn.removeAttribute("disabled");
                } else {
                  bundleBtn.setAttribute("disabled", true);
                }
              };
            });
          }
        }
      });
    }
  },
  productPageAccordion: function () {
    // accordion default selected
    if (document.querySelector("body#product") != null) {
      if (document.querySelectorAll(".dropship-accordion-section") != null) {
        var accordion = document.querySelectorAll(
          ".dropship-accordion-section"
        );
        accordion.forEach(function (item, index) {
          if (index == 0) {
            item.querySelector(".collapse").classList.add("show");
            item
              .closest(".dropship-accordion-section")
              .querySelector(".accordion-toggle")
              .classList.remove("collapsed");
            item
              .closest(".dropship-accordion-section")
              .querySelector(".accordion-toggle")
              .setAttribute("aria-expanded", true);
          }
        });
      }
    }
  },
  contactFormEmailValidations: function () {
    var form = document.querySelector("#contact-form");
    if (form != null) {
      var submitBtn = form.querySelector("#contact-submit");
      var email = form.querySelector("#ContactFormEmail");
      var errorWrp = form.querySelector(".validate-email-address");
      if (form != null && email != null) {
        submitBtn.onclick = function (e) {
          e.preventDefault();
          var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
          var errorMessage = "";
          if (email.value == "") {
            errorMessage = `<div class="errors"><ul><li>Please enter valid email address.</li></ul></div>`;
          } else if (!email.value.match(mailFormat)) {
            errorMessage = `<div class="errors"><ul><li>Email is invalid, Please enter valid email address.</li></ul></div>`;
          }
          if (errorMessage != "") {
            errorWrp.innerHTML = errorMessage;
          } else {
            form.submit();
          }
        };
      }
    }
  },
  newsletterFormEmailValidations: function () {
    var form = document.querySelector(".newsletter_form");
    var submitBtn = form.querySelector(".newsletterSubscribe");
    var email = form.querySelector(".EmailNewsletter");
    var errorWrp = form.querySelector(".validate-nwsemail-address");
    if (form != null && email != null) {
      form.onsubmit = function (e) {
        // Prevent the default form submission behavior
        e.preventDefault();
        // validation
        var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var errorMessage = "";
        if (email.value == "") {
          errorMessage = `<div class="errors"><ul class="text-left"><li>Please enter valid email address.</li></ul></div>`;
        } else if (!email.value.match(mailFormat)) {
          errorMessage = `<div class="errors"><ul class="text-left"><li>Email is invalid, Please enter valid email address.</li></ul></div>`;
        }
        if (errorMessage != "") {
          errorWrp.innerHTML = errorMessage;
        } else {
          form.submit();
        }
        // Scroll to the bottom of the page
        window.scrollTo(0, document.body.scrollHeight);
      };
    }
    if (window.location.href.indexOf("customer_posted=true") > -1) {
      window.scrollTo(0, document.body.scrollHeight);
      const newsletterInterval = setInterval(function () {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);

      setTimeout(function () {
        clearInterval(newsletterInterval);
      }, 2000);
    }
  },
  reviewsSectionSlider: function (e) {
    //console.log('e.type review section',e.type);
    var allSlidersWrp = document.querySelectorAll(
      ".main-reviews-section-slider-inner-wrp"
    );
    if (allSlidersWrp.length > 0) {
      allSlidersWrp.forEach(function (sliderWrp) {
        var speed = sliderWrp.dataset.speed;
        var section_id = sliderWrp.dataset.section;
        if (e.detail != undefined) {
          if (e.detail.sectionId == section_id) {
            //console.log('Its review section');
            if (e.type == "shopify:section:reorder") {
              return;
            }
          } else {
            //console.log('another section editing');
            return;
          }
        }
        //console.log('review section loading',section_id);
        speed = parseInt(speed + "00");

        fetch("/?sections=" + section_id)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            html = JSON.parse(html);
            html = html[section_id];
            var doc = parser.parseFromString(html, "text/html");
            var sidederInnerWrp = doc.querySelector(
              ".main-reviews-section-slider-inner-wrp"
            ).innerHTML;
            if (sidederInnerWrp != "") {
              sliderWrp.innerHTML = "";
              sliderWrp.innerHTML = sidederInnerWrp;
              var sliderElement = sliderWrp.querySelector(
                ".main-reviews-section-slider"
              );
              if (sliderElement != null) {
                reviewSliderCreate(sliderWrp, sliderElement, speed);
              }
            }
          })
          .catch(function (err) {
            console.log("Failed to fetch page: ", err);
            var sliderElement = sliderWrp.querySelector(
              ".main-reviews-section-slider"
            );
            if (sliderElement != null) {
              reviewSliderCreate(sliderWrp, sliderElement, speed);
            }
          });
      });
      function reviewSliderCreate(sliderWrp, sliderElement, speed) {
        //console.log(sliderElement);
        sliderElement.classList.remove("main-reviews-section-no-slider");
        var slider = tns({
          container: sliderElement,
          disable: false,
          items: 1,
          speed: speed,
          autoplayTimeout: 4200,
          mouseDrag: true,
          autoplay: true,
          controls: false,
          loop: true,
          onInit(info) {
            console.log("initslider", info);
          },
        });
        var i = 0;
        var customizedFunction = function (info, eventName) {
          //console.log('info',info.displayIndex,info.navCurrentIndex);
          if (sliderWrp.querySelector(".reviews__progress__bar") != null) {
            if (sliderWrp.querySelector(".reviews-carousel__count") != null) {
              var indexCurrent = info.displayIndex;
              sliderWrp.querySelector(".reviews-carousel__count").innerHTML =
                "0" + indexCurrent;
            }
            if (i != info.displayIndex) {
              sliderWrp
                .querySelector(".reviews__progress__bar")
                .classList.remove("reviews-anim-active");
              setTimeout(function () {
                sliderWrp
                  .querySelector(".reviews__progress__bar")
                  .classList.add("reviews-anim-active");
              }, 100);
              i = info.displayIndex;
            }
          }
        };
        slider.events.on("indexChanged", customizedFunction);
      }
    }
  },
  featuredCollectionListSlider: function (e) {
    var allSlidersWrp = document.querySelectorAll(
      ".main-featured-collection-list"
    );
    if (allSlidersWrp.length > 0) {
      allSlidersWrp.forEach(function (sliderWrp) {
        var sliderParent = sliderWrp.closest("section");
        var section_id = sliderParent.getAttribute("id");
        if (e.detail != undefined) {
          if (e.detail.sectionId == section_id) {
            if (e.type == "shopify:section:reorder") {
              return;
            }
          } else {
            return;
          }
        }
        var slider2 = tns({
          container: sliderWrp,
          items: 1,
          disable: true,
          slideBy: "1",
          nav: false,
          speed: 400,
          mode: "carousel",
          prevButton: "#id_" + section_id + " .js-slider-sites-prev",
          nextButton: "#id_" + section_id + " .js-slider-sites-next",
          navPosition: "bottom",
          autoplayButtonOutput: false,
          mouseDrag: true,
          autoplay: false,
          controls: true,
          freezable: true,
          touch: false,
          mouseDrag: false,
          preventScrollOnTouch: "true",
          rewind: true,
          lazyload: true,
          center: false,
          loop: false,
          controlsContainer: "#id_" + section_id + " .slider-sites__nav",
          onInit(info) {
            info.controlsContainer.setAttribute("tabindex", -1);
            info.nextButton.setAttribute("tabindex", -1);
            info.prevButton.setAttribute("tabindex", -1);
          },
          responsive: {
            320: {
              items: 1,
              disable: false,
            },
            640: {
              items: 3,
              disable: false,
            },
            768: {
              items: 4,
              disable: false,
            },
          },
        });
        slider2.refresh();
      });
    }
  },
  sizeGuideTabs: function () {
    var tabs = document.querySelectorAll(".size-guide-tab-listing li");
    if (tabs.length > 0) {
      tabs.forEach(function (tab) {
        tab.onclick = function (e) {
          e.preventDefault();
          var rows = tab
            .closest(".size-guide-wrp")
            .querySelectorAll(".size-guide-table-wrp table");
          if (rows.length > 0) {
            rows.forEach(function (row) {
              row.classList.add("hidden");
            });
          }
          tabs.forEach(function (tab) {
            tab.classList.remove("active-tab");
          });
          var table = tab.dataset.table;
          var row = tab.closest(".size-guide-wrp").querySelector("." + table);
          row.classList.remove("hidden");
          tab.classList.add("active-tab");
        };
      });
    }
  },
  featuredCategoriesListSlider: function (e) {
    var allSlidersWrp = document.querySelectorAll(
      ".new-featured-categories-list"
    );
    if (allSlidersWrp.length > 0) {
      allSlidersWrp.forEach(function (sliderWrp) {
        var sliderParent = sliderWrp.closest("section");
        var section_id = sliderParent.getAttribute("id");
        if (e.detail != undefined) {
          if (e.detail.sectionId == section_id) {
            if (e.type == "shopify:section:reorder") {
              return;
            }
          } else {
            return;
          }
        }
        var slider2 = tns({
          container: sliderWrp,
          items: 1,
          disable: true,
          slideBy: "1",
          nav: false,
          speed: 400,
          mode: "carousel",
          prevButton: "#id_" + section_id + " .js-slider-sites-prev",
          nextButton: "#id_" + section_id + " .js-slider-sites-next",
          navPosition: "bottom",
          autoplayButtonOutput: false,
          mouseDrag: true,
          autoplay: false,
          controls: true,
          freezable: true,
          touch: false,
          mouseDrag: false,
          preventScrollOnTouch: "true",
          rewind: true,
          lazyload: true,
          center: false,
          loop: false,
          controlsContainer: "#id_" + section_id + " .slider-sites__nav",
          onInit(info) {
            info.controlsContainer.setAttribute("tabindex", -1);
            info.nextButton.setAttribute("tabindex", -1);
            info.prevButton.setAttribute("tabindex", -1);
          },
          responsive: {
            320: {
              items: 1,
              disable: false,
            },
            640: {
              items: 2,
              disable: false,
            },
            1000: {
              items: 3,
              disable: false,
            },
            1250: {
              items: 4,
              disable: false,
            },
          },
        });
        slider2.refresh();
      });
    }
  },
  productMediaVideoControls: function (e) {
    var videosWrp = document.querySelectorAll(
      ".external-video-container,.video-container"
    );
    if (videosWrp.length > 0) {
      videosWrp.forEach(function (videoWrp) {
        //console.log('videoWrp', videoWrp);
        var controls = videoWrp.querySelectorAll(
          ".video-controls-btn .video-control"
        );
        if (controls.length > 0) {
          controls.forEach(function (control) {
            control.onclick = function () {
              var command;
              var iframe = videoWrp.querySelector("iframe");
              var video = videoWrp.querySelector("video");
              console.log(iframe);
              if (control.classList.contains("video-play")) {
                control.classList.add("hidden");
                if (iframe != null) {
                  if (iframe.classList.contains("js-vimeo")) {
                    command = {
                      method: "play",
                      value: "true",
                    };
                  }
                  if (iframe.classList.contains("js-youtube")) {
                    command = {
                      event: "command",
                      func: "playVideo",
                    };
                  }
                  iframe.contentWindow.postMessage(
                    JSON.stringify(command),
                    "*"
                  );
                } else if (video != null) {
                  video.play();
                }
              }
              if (control.classList.contains("video-pause")) {
                control.classList.add("hidden");
                if (iframe != null) {
                  if (iframe.classList.contains("js-vimeo")) {
                    command = {
                      method: "pause",
                      value: "true",
                    };
                  }
                  if (iframe.classList.contains("js-youtube")) {
                    command = {
                      event: "command",
                      func: "pauseVideo",
                    };
                  }
                  iframe.contentWindow.postMessage(
                    JSON.stringify(command),
                    "*"
                  );
                } else if (video != null) {
                  video.pause();
                }
              }
              controls.forEach(function (controlC) {
                if (control != controlC) {
                  controlC.classList.remove("hidden");
                }
              });
              // others pause
              videosWrp.forEach(function (videoWrpCurrent) {
                if (videoWrpCurrent != videoWrp) {
                  var controlsCurrent = videoWrpCurrent.querySelectorAll(
                    ".video-controls-btn .video-control"
                  );
                  if (controlsCurrent.length > 0) {
                    controlsCurrent.forEach(function (controlCurrent) {
                      if (controlCurrent.classList.contains("video-play")) {
                        controlCurrent.classList.remove("hidden");
                      } else {
                        controlCurrent.classList.add("hidden");
                      }
                    });
                  }
                  var iframe = videoWrpCurrent.querySelector("iframe");
                  var video = videoWrpCurrent.querySelector("video");
                  if (iframe != null) {
                    if (iframe.classList.contains("js-vimeo")) {
                      command = {
                        method: "pause",
                        value: "true",
                      };
                    }
                    if (iframe.classList.contains("js-youtube")) {
                      command = {
                        event: "command",
                        func: "pauseVideo",
                      };
                    }
                    iframe.contentWindow.postMessage(
                      JSON.stringify(command),
                      "*"
                    );
                  } else if (video != null) {
                    video.pause();
                  }
                }
              });
            };
          });
        }
      });
    }
  },
  initAllSections: function (e) {
    globalSectonsFunction.featuredSectionSlider(e);
    globalSectonsFunction.alternativeRichTextSection();
    globalSectonsFunction.bundleProductsSection();
    globalSectonsFunction.productPageAccordion();
    globalSectonsFunction.contactFormEmailValidations();
    globalSectonsFunction.newsletterFormEmailValidations();
    if (e.type != "resize") {
      globalSectonsFunction.reviewsSectionSlider(e);
    }
    globalSectonsFunction.sizeGuideTabs();
    globalSectonsFunction.featuredCollectionListSlider(e);
    globalSectonsFunction.featuredCategoriesListSlider(e);
    globalSectonsFunction.productMediaVideoControls(e);
  },
};
document.addEventListener("DOMContentLoaded", function (e) {
  globalSectonsFunction.initAllSections(e);
});
document.addEventListener("shopify:section:load", function (e) {
  globalSectonsFunction.initAllSections(e);
});
document.addEventListener("shopify:section:unload", function (e) {
  globalSectonsFunction.initAllSections(e);
});
document.addEventListener("shopify:section:reorder", function (e) {
  globalSectonsFunction.initAllSections(e);
});
window.addEventListener("resize", function (e) {
  globalSectonsFunction.initAllSections(e);
});

function updateProductMediaAndOther(){
  setTimeout(function(){
  var mediaAll = document.querySelectorAll(
    ".product-media-desktop-only div#product-image .slides>div:not(div#product-image .slides>div:first-child)"
  );
  if (mediaAll.length > 0) {
    mediaAll.forEach(function (media) {
      media.style.display = "inline-block";
    });
  }
  var paymentBtn = document.querySelector(
    ".single-product-details .shopify-payment-button"
  );
  if (paymentBtn != null) {
    paymentBtn.style.display = "block";
  }
  var pickup = document.querySelector("pickup-availability");
  if (pickup != null) {
    pickup.style.display = "block";
  }
  },500);
}

window.addEventListener("scroll", function (e) {
   updateProductMediaAndOther();
});
document.addEventListener("DOMContentLoaded", function (e) {
   updateProductMediaAndOther();
});
document.addEventListener("shopify:section:load", function (e) {
   updateProductMediaAndOther();
});
document.addEventListener("shopify:section:unload", function (e) {
   updateProductMediaAndOther();
});
document.addEventListener("shopify:section:reorder", function (e) {
   updateProductMediaAndOther();
});
